module.exports = __webpack_public_path__ + "img/success-case-0.b2028935.png";